import {
  T2,
  toast,
  Loader,
  useActivityTracker,
  getTranslatedText,
  useIntl,
  AppContext,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components'
import {
  planDescriptionKeyMap,
  oldNewPlanOrderIdMapping,
  oldNewPlanOrderIdMappingFlag
} from '@nile/banyan/src/Utils/pricingHelper'
import { PlanDetailCard } from '@nile/components/src/Cards'
import { UpgradeLicenseSheet } from '@nile/components/src/Sheets'
import {
  AccountClient,
  UPGRADE_SUBSCRIPTION_STATUS,
  GET_PRODUCT_FEATURES,
  UPGRADE_SUBSCRIPTION,
  GET_PURCHASE_PRODUCT_FEATURE_META,
  GET_CUSTOMER_SUBSCRIPTION
} from '@nile/graphql'
import { SVGIcon } from '@superops/super-icons'
import {
  Page,
  Button,
  ButtonGroup,
  TextStyle
} from '@superops/ui-design-system'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import {
  ModifyTechnician,
  ManageAssetModal,
  AddTechEndpoint
} from '@nile/banyan/src/Pages/Protected/Configuration/Pricing'
import { isEmpty } from 'lodash'
import { useFlags } from 'launchdarkly-react-client-sdk'
import dayjs from 'dayjs'
import ITPricingEstimateContainer from '@nile/banyan/src/Pages/Protected/Configuration/Pricing/ITPricingEstimateContainer'

const UpgradePlanSheetWrapper = styled.div`
  padding: 0px 35px;
  .name {
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #ff1462;
    margin-bottom: 6px;
  }
  .excerpt {
    font-family: Poppins, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    color: #4d4d4d;
  }
  .line {
    width: 88px;
    height: 2px;
    border-top: 2px solid #f05;
    margin: 10px 0;
  }
  .f11 {
    flex: 1 1;
    height: 100%;
    overflow: auto;
  }
  .f31 {
    flex: 3 1;
    height: 100%;
    overflow: auto;
  }
  .modal-title {
    font-size: 32px;
    line-height: 1.2;
  }
  .description {
    font-size: 12px;
    font-style: italic;
    font-weight: normal !important;
  }
  .btn-switcher {
    .Polaris-ButtonGroup--segmented .Polaris-ButtonGroup__Item {
      margin: 0;
    }
    .isActivated {
      border: 1px solid black;
    }
  }
`

const SuperPlusContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;

  flex: 3 1;
  height: 100%;
  overflow: auto;

  .title {
    color: #212b36;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
  }

  .sub {
    margin: 5px auto 20px;
    max-width: 440px;
  }

  .Superops-Button {
  }
`

const UpgradePlanSheet = (props) => {
  const {
    subscription,
    plans,
    tenure,
    currency,
    locale,
    closeModal,
    isTieredModel,
    planChange = false
  } = props
  const flags = useFlags()

  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP)

  const [updatedTenure, setUpdatedTenure] = useState(tenure)

  const [availablePlans, setAvailablePlans] = useState(plans || [])

  const [openManageTechModal, setOpenManageTechModal] = useState(false)
  const [openManageAssetModal, setOpenManageAssetModal] = useState(false)
  const [currentSubscription, setCurrentSubscription] = useState(null)

  const handleManageModal = useCallback((type) => {
    if (type === 'TECHNICIAN') {
      setOpenManageTechModal((prevState) => !prevState)
    }
    if (type === 'NETWORK_ASSET') {
      console.log('Manage asset change')
      setOpenManageAssetModal((prevState) => !prevState)
    }
  }, [])

  const intl = useIntl()

  const checkIsSuperPlus = (chargeBeePlanId) => {
    setIsSuperPlus(chargeBeePlanId === 'Super_Plus')
  }

  const appContext = useContext(AppContext)
  const { user, isTrialUser } = appContext

  const userMeta = {
    email: user.email,
    name: user.name,
    userId: user.userId,
    subscriptionStatus: user.subscriptionStatus,
    currentPlan: currentSubscription?.currentPlanPrice?.plan?.planName,
    chargeBeePlanId:
      currentSubscription?.currentPlanPrice?.plan?.chargeBeePlanId,
    billingPeriod: currentSubscription?.billingPeriod,
    licenseCount: currentSubscription?.licenseCount,
    addOnsCount: currentSubscription?.subscribedAddons?.length,
    nextBillingDateTime: dayjs(currentSubscription?.nextBillingDateTime).format(
      'MMM DD, YYYY'
    )
  }

  const [plan, setPlan] = useState(null)
  const [allFeatures, setAllFeatures] = useState([])
  const [pricingMeta, setPricingMeta] = useState([])
  const [pricingMetaLoading, setPricingMetaLoading] = useState(false)
  const [isSuperPlus, setIsSuperPlus] = useState(false)

  const getAllFeatures = () => {
    AccountClient.query({
      query: GET_PRODUCT_FEATURES,
      variables: {
        input: {
          includePurchaseOnlyFeatures: true
        }
      }
    }).then((res) => {
      if (res?.data?.getProductFeaturesCategories) {
        setAllFeatures(res.data.getProductFeaturesCategories)
      }
    })
  }

  const getPricingMeta = () => {
    setPricingMetaLoading(true)
    AccountClient.query({ query: GET_PURCHASE_PRODUCT_FEATURE_META }).then(
      (res) => {
        const result = res?.data?.getPurchaseProductFeatureMeta
        setPricingMeta(isMSPProduct ? result?.mspData : result?.itData)
        setPricingMetaLoading(false)
      }
    )
  }

  const getCustomerSubscription = () => {
    AccountClient.query({
      query: GET_CUSTOMER_SUBSCRIPTION,
      fetchPolicy: 'network-only'
    })
      .then(async (res) => {
        if (res?.data?.getCustomerSubscription) {
          setCurrentSubscription(res.data.getCustomerSubscription)
        }
      })
      .finally(() => {})
  }

  useEffect(() => {
    if (!isTrialUser) {
      getCustomerSubscription()
    }
  }, [])

  useEffect(() => {
    const newPlanMappedID =
      oldNewPlanOrderIdMappingFlag[
        subscription?.currentPlanPrice?.plan?.chargeBeePlanId
      ]
    const currentPlanOrder = newPlanMappedID
      ? plans.filter((pln) => pln.chargeBeePlanId === newPlanMappedID)?.[0]
          ?.planOrder
      : 0

    const updatedPlans = plans.filter((pln) => pln.planOrder > currentPlanOrder)
    setAvailablePlans(updatedPlans)
    if (!isEmpty(updatedPlans)) {
      checkIsSuperPlus(updatedPlans[0]?.chargeBeePlanId)
      setPlan(updatedPlans[0])
    }
    getAllFeatures()
    getPricingMeta()
  }, [])

  const selectPlan = (planOrder) => {
    // const updatedPlan = availablePlans.filter(
    //   (pln) => pln.planOrder === planOrder
    // )
    // if (updatedPlan.length) {
    //   setPlan(updatedPlan?.[0])
    // }

    const updatedPlan = availablePlans[planOrder]

    checkIsSuperPlus(updatedPlan?.chargeBeePlanId)

    if (updatedPlan) {
      setPlan(updatedPlan)
    }
  }

  const onUpgradeHandler = (planEstimate, licenseCount) => {
    const chargebeeInstance = window.Chargebee.getInstance()
    chargebeeInstance.openCheckout({
      hostedPage: function () {
        return AccountClient.mutate({
          mutation: UPGRADE_SUBSCRIPTION,
          variables: {
            input: {
              chargeBeePlanPriceId:
                planEstimate?.plan?.planPrice?.chargeBeePlanPriceId,
              addons: !isEmpty(planEstimate?.addons)
                ? planEstimate?.addons
                    .map((el) =>
                      licenseCount[el?.addonPrice?.chargeBeeAddonPriceId]
                        ? {
                            chargeBeeAddonPriceId:
                              el?.addonPrice?.chargeBeeAddonPriceId,
                            quantity:
                              licenseCount[
                                el?.addonPrice?.chargeBeeAddonPriceId
                              ]
                          }
                        : null
                    )
                    .filter((el) => el)
                : [],
              quantity: licenseCount?.TECHNICIAN
            }
          }
        }).then((res) => {
          useActivityTracker({
            event: 'Inproduct purchase',
            data: {
              source: 'proceed to payment upgrade plan',
              subscription: planEstimate?.plan?.planPrice?.chargeBeePlanPriceId,
              techCount: licenseCount?.TECHNICIAN
            }
          })
          if (res?.data?.upgradeSubscription) {
            return res.data.upgradeSubscription
          }
        })
      },
      success: function () {
        AccountClient.mutate({
          mutation: UPGRADE_SUBSCRIPTION_STATUS,
          variables: {
            input: {
              status: 'SUCCESS'
            }
          }
        }).then((res) => {
          if (res?.data?.updateSubscriptionPurchaseStatus) {
            useActivityTracker({
              event: 'Inproduct purchase',
              data: {
                source: 'upgrade plan payment conformation',
                subscription:
                  planEstimate?.plan?.planPrice?.chargeBeePlanPriceId,
                techCount: licenseCount?.TECHNICIAN
              }
            })
            toast('success', 'Payment successful')
            chargebeeInstance.closeAll()
            window.location.reload()
          } else {
            useActivityTracker({
              event: 'Inproduct purchase',
              data: {
                source: 'upgrade plan payment inprogress',
                subscription:
                  planEstimate?.plan?.planPrice?.chargeBeePlanPriceId,
                techCount: licenseCount?.TECHNICIAN
              }
            })
            chargebeeInstance.closeAll()
            window.location.reload()
          }
        })
      },
      close: function () {
        AccountClient.mutate({
          mutation: UPGRADE_SUBSCRIPTION_STATUS,
          variables: {
            input: {
              status: 'CANCEL'
            }
          }
        }).then((res) => {
          if (res?.data?.updateSubscriptionPurchaseStatus) {
            useActivityTracker({
              event: 'Inproduct purchase',
              data: {
                source: 'E. Payment cancelled',
                subscription:
                  planEstimate?.plan?.planPrice?.chargeBeePlanPriceId,
                techCount: licenseCount?.TECHNICIAN
              }
            })
          }
          chargebeeInstance.closeAll()
        })
      }
    })
  }
  if (pricingMetaLoading) {
    return (
      <div className='vh100'>
        <Loader />
      </div>
    )
  }

  if (!plan) {
    return <Loader />
  }

  return (
    <>
      {!openManageTechModal && !openManageAssetModal && (
        <Page
          variant='secondary'
          contentHeight='100px'
          divider
          title={`Upgrading from ${subscription?.currentPlanPrice?.plan
            ?.planName || 'NA'} to ${plan?.planName || 'NA'} plan`}
          primaryAction={
            <Button
              plain
              onClick={() => closeModal(false)}
              icon={<SVGIcon name='Close' />}
            />
          }
        >
          <UpgradePlanSheetWrapper className='flex full-height'>
            <div className='f11'>
              <PlanDetailCard
                selectedPlan={plan}
                isNew
                availablePlans={availablePlans}
                isUpgradeCard
                selectPlan={selectPlan}
                allFeatures={pricingMeta?.featureList}
                planFeatures={pricingMeta?.planProductFeatures}
                subscriptionTypes={pricingMeta?.subscriptionTypes}
              />
            </div>
            {isSuperPlus ? (
              <>
                <SuperPlus userMeta={userMeta} />
              </>
            ) : (
              <div className='f31 ml-20'>
                <div className='fx title-wrapper'>
                  <div className='f11 mt-20'>
                    <div>
                      <p className='name'>{plan?.planName}</p>
                      <p className='excerpt'>
                        <T2>
                          {plan?.chargeBeePlanId
                            ? getTranslatedText(
                                intl,
                                planDescriptionKeyMap[plan?.chargeBeePlanId]
                              )
                            : ''}
                        </T2>
                      </p>
                      <T2 className='desc italic'>
                        Price for
                        <span className='mlr5'>
                          <TextStyle weight='Bold'>{plan?.planName}</TextStyle>
                        </span>
                        subscription on
                        <span className='mlr5'>
                          <TextStyle weight='Bold'>
                            {tenure === 'MONTHLY' ? 'monthly' : 'annual'}
                          </TextStyle>
                        </span>
                      </T2>
                      <div className='line' />
                    </div>
                  </div>
                  <div className='flex jend btn-switcher mt-20 mb-20'>
                    <ButtonGroup segmented>
                      <Button
                        outline={updatedTenure === 'MONTHLY'}
                        onClick={() => setUpdatedTenure('MONTHLY')}
                        disabled={
                          subscription?.currentPlanPrice?.duration === 'YEARLY'
                        }
                      >
                        <FormattedMessage id='admin.billing.upgradeplan.tenure.monthly' />
                      </Button>
                      <Button
                        outline={updatedTenure === 'YEARLY'}
                        onClick={() => setUpdatedTenure('YEARLY')}
                      >
                        <FormattedMessage id='admin.billing.upgradeplan.tenure.yearly' />
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
                {plan ? (
                  <>
                    {!isTieredModel ? (
                      <UpgradeLicenseSheet
                        subscription={subscription}
                        plan={plan}
                        tenure={updatedTenure}
                        currency={currency}
                        locale={locale}
                        onUpgradeHandler={onUpgradeHandler}
                        handleManageModal={handleManageModal}
                        superTip={
                          <FormattedMessage id='admin.billing.upgradeplan.superTip' />
                        }
                      />
                    ) : (
                      <ITPricingEstimateContainer
                        selectedPlan={plan}
                        tenure={updatedTenure}
                        currency={currency}
                        locale={locale}
                        intl={intl}
                        subscription={subscription}
                        setTenure={setUpdatedTenure}
                        isUpgrade
                        isTieredModel={isTieredModel}
                        planChange={planChange}
                      />
                    )}
                  </>
                ) : (
                  <div>
                    <FormattedMessage id='admin.billing.upgradeplan.noplans' />
                  </div>
                )}
              </div>
            )}
          </UpgradePlanSheetWrapper>
        </Page>
      )}
      {openManageTechModal && (
        <ModifyTechnician closePage={handleManageModal} />
      )}
      {openManageAssetModal && (
        <ManageAssetModal closePage={handleManageModal} />
      )}
    </>
  )
}

export default withRouter(UpgradePlanSheet)

const SuperPlus = (props) => {
  const { userMeta } = props

  return (
    <SuperPlusContainer>
      <p className='title'>
        <FormattedMessage id='app.pricing.contactsupport' />
      </p>

      <p className='sub'>
        Superplus is based on asset wise pricing. To know more details and buy
        this plan, Contact support
      </p>
      <Button
        onClick={() => {
          window.Intercom('trackEvent', 'upgrade-from-old-plan', userMeta)
        }}
        primary
      >
        Get a callback
      </Button>
    </SuperPlusContainer>
  )
}
